(function() {
    'use strict';

    angular
        .module('app.service')
        .factory('bulletinService', bulletinService);

    function bulletinService(apiUrl, $http, sysCode, commonService, $q, headerService) {
        var service = {
            getByNo: getByNo,
            getMore: getMore,
            getNoticeMore: getNoticeMore,
            getMoreByChoice: getMoreByChoice,
            getByNoForTsun: getByNoForTsun,
            donwloadStampForUrl: donwloadStampForUrl,
            checkHeadStatus: checkHeadStatus,
            getStampFile: getStampFile,
            getTsunMoreList: getTsunMoreList
        };

        var url = apiUrl.tsApi + 'bulletin/';
        var noticeUrl = apiUrl.tsApi + 'notifyCenter/';

        function getByNo(bulletinSerilNo) {
            var param = {
                bulletinSerilNo: bulletinSerilNo
            };
            commonService.setParams(param);
            headerService.saveEnforcementReadRecord(bulletinSerilNo);
            return $http.post(url + 'bulletin', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
			
        }

        function getByNoForTsun(notifySerilNo) {
            var param = {
                notifySerilNo: notifySerilNo,
                menuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            headerService.saveEnforcementReadRecord(notifySerilNo);
            return $http.post(noticeUrl + 'noticeGetForPerson', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
        }

        function getMore(siteCode, isHistory) {
            var param = {
                siteCode: siteCode,
                menuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            if (isHistory) {
                var bulletinCache = JSON.parse(sessionStorage.getItem('bulletinCache'));
                if (bulletinCache) {
                    if (bulletinCache.menuItem) {
                        param.menuSerilNo = bulletinCache.menuItem.menuSerilNo;
                    }
                    if (bulletinCache.typeSerilNo) {
                        param.bulletinTypeSerilNo = bulletinCache.typeSerilNo;
                    }
                }
            }
            return $http.post(url + 'more', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
        }

        function getTsunMoreList(param) {

            commonService.setParams(param);
            return $http.post(url + 'noticeMoreList', param);
        }

        function getNoticeMore() {
            var param = {
                menuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            return $http.post(url + 'noticeMore', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
        }

        function getMoreByChoice(param) {
            commonService.setParams(param);
            return $http.post(url + 'bulletinChoiceByLogin', param);
        }

        function checkHeadStatus() {
            
            return $q.when(true);
        }

        function donwloadStampForUrl(param) {
            //2023-07-21 Johnson ��w2023
            console.log('donwloadStampForUrl:visualpageController�w����');

        }

        function getStampFile(attachmentSerilNo) {
            // console.log(format('{0}download/{1}/{2}/{3}/{4}/{5}',
            //     url, attachmentSerilNo, sysCode, getMenuQueryString(),
            //     sessionStorage.getItem('token'), sessionStorage.getItem('perSerilNo')))
            return format('{0}download/{1}/{2}/{3}/{4}/{5}',
                url, attachmentSerilNo, sysCode, getMenuQueryString(),
                sessionStorage.getItem('token'), sessionStorage.getItem('perSerilNo'));
        }

        return service;
    }
})();